module.exports = __webpack_public_path__ + "img/Historicaltransactions.f0c4b36b.png";